export enum MGSAEntityTypes {
  Mindsets = 'mindsets',
  Skills = 'skills',
  Goals = 'goals',
}
